export default function (data, element, skipBinding, course_id) {
  var self = this;

  self.domId = ko.observable(new Date().getTime());
  self.$el = $(element);
  self.course_id = course_id;
  self.resource_id = ko.observable();
  self.resource = ko.observable();
  self.resource_type = ko.observable();
  self.option_select_text = I18n.t('resource.choose_type');
  self.saving = ko.observable(false);
  self.dummyBool = ko.observable(true); //used to force computed observable to update
  self.serverErrors = ko.observableArray();
  self.clientErrors = ko.observableArray();
  self.uploading = ko.observable(false);
  self.saveBtnTxt = ko.observable(I18n.t('dict.save').capitalize_first());
  self.multiResourceSelectionEnabled = ko.observable(false);
  self.changeStatusMode = ko.observable('');


  self.maxFilesize = Kadenze.isKadenze ? 2000 : 500;

  //
  // TODO: cleanup this unique way of handling status
  //
  self.isPublished = ko.computed(() => self.changeStatusMode() === 'published')
  self.isDraft = ko.computed(() => !self.isPublished())

  //
  // TODO: could not clean out this magic string
  // get the resource mapping to match the `isDownload` in the resource json
  //
  self.isDownload = ko.computed(() => self.resource_type() === 'DownloadResource')

  self.isEmbeddedVideo = data.is_embedded_video

  self.defaultNoticeOptions = {
    parentObject: '.instructor-edit--sidebar',
    method: 'append'
  };

  self.showImagePreview = $parent => {
    //
    // TODO: is this function even called?
    //
    if (self.resource().attachment() && self.resource().attachment().isImage()) {
      $img_preview = $(
        JST['templates/img-preview']({
          title: I18n.t('wizard.preview'),
          image: self.resource().attachment().file.url()
        })
      );
      $parent.appendChild($img_preview[0]);
    }
  };

  self.setResourceType = function(type, $data) {
    $('.kadenze-tooltip').hide();
    $('#initial_load').text('false');
    self.resource_type(type);
    self.multiResourceSelectionEnabled(false);

    var $el = $('.js-resource-img-dz', self.$el)[0];

    self.showLogoDropzone($el);
  };

  self.enableMultiResourceSelection = function(){
    $('.kadenze-tooltip').hide();
    $('#initial_load').text('false');
    self.multiResourceSelectionEnabled(true);
  };

  self.preview = function() {
    const response = self.save();

    response.success(function () {
      const previewOptions = {
        preview: true,
        exit_path: encodeURI(window.location.pathname),
        id: self.resource().id()
      };

      window.location = Kadenze.Routes.course_resource_path(self.course_id, previewOptions);
    });
  };

  // Options to be passed to datetimepicker
  self.publishDateOptions = {
    format: 'MM/DD/YYYY',
    setDate: moment().subtract('1', 'year'),
    maxDate: moment(),
    constrainInput: false,
    pickTime: false
  };

  var ResourceOption = function(type) {
    this.value = type + 'Resource';
    this.name = I18n.t('resource.type.' + type.charAt(0).toLowerCase() + type.slice(1));
  };

  self.available_types = ko.observableArray([
    new ResourceOption('Book'),
    new ResourceOption('Link'),
    new ResourceOption('Software'),
    new ResourceOption('Download'),
    new ResourceOption('EmbeddedVideo')
  ]);

  self.previewVideo = function()
  {
    if(self.resource().info && self.resource().info.embedded_video_url)
    {
      //extract src attr from video url
      // src="//www.youtube.com/embed/OiDfDz_sw4s"
      // for https://www.youtube.com/watch?v=OiDfDz_sw4s
      // src="//player.vimeo.com/video/106066985"
      // for https://vimeo.com/106066985

      var vurl = self.resource().info.embedded_video_url().trim();
      var vsrc = '';

      if(vurl.match(/vimeo\.com/i))
      {
        vsrc = vurl.substring(vurl.lastIndexOf('/') + 1);
        vsrc = '//player.vimeo.com/video/' + vsrc;
      }
      else if (vurl.match(/youtube\.com/i))
      {
        vsrc = vurl.substring(vurl.lastIndexOf('v=') + 2);
        vsrc = '//www.youtube.com/embed/' + vsrc;
      }
      else if (vurl.match(/\/\/youtu\.be/i))
      {
        vsrc = vurl.substring(vurl.lastIndexOf('/') + 1);
        vsrc = '//www.youtube.com/embed/' + vsrc;
      }
      self.$el.find('#video-preview iframe').attr('src', vsrc);

      if(vsrc !== '')
        self.$el.find('#video-preview').show(500);
      else
        self.$el.find('#video-preview').attr('src', vsrc).hide();
    }
  };

  self.savedAtText = ko.computed(function() {
    self.dummyBool();
    if (self.saving()) {
      return I18n.t('dict.saving');
    }
    else if (self.resource && self.resource() && self.resource().updated_at()) {
      return I18n.t('dict.last_saved_at') + ' ' + moment(self.resource().updated_at()).fromNow();
    }
    else {
      return '';
    }
  });

  self.initUI = function() {
    if (!self.$el || self.$el.length === 0) {
      self.$el = $('#' + self.domId());
    }

    // self.resource_type() is not yet defined here
    // ideally either logo or download is init'd if DownloadResource
    self.initLogoDropzone();
    self.initDownloadDZ();

    // Remove the null option if the user changes the type to something valid
    // See KADWEB-9849
    if(!_.isUndefined(self.resource_type())) {
      let $list = $('button[data-id=\'resourceSelectMenu\']').next();
      $list.find('li').first().remove();
      $('#resourceSelectMenu').find('option:contains(\'Select Resource Type\')').remove();
    }

    if (self.isEmbeddedVideo)
      self.previewVideo()
  };

  self.initLogoDropzone = function() {
    var $el = $('.js-resource-img-dz', self.$el);
    if (!$el.attr('id')) {
      $el.attr('id', 'resource-logo-dz-' + new Date().getTime());
    }
    var $imageInput = $('.js-resource-img-path', self.$el);
    var $removeInput = $('.js-resource-img-remove', self.$el);

    var fileObj;

    if (typeof self.resource().logo_path === 'function') {
      if (self.resource().logo_path() !== null) {
        fileObj = {
          previewable: true,
          dzPreview: JST['templates/dropzone-generic-img-preview']({ previewable: true,
            nameLabel: I18n.t('file_preview.name'),
            sizeLabel: I18n.t('file_preview.size'),
            previewLabel: I18n.t('file_preview.preview'),
            removeLabel: I18n.t('file_preview.remove_file'),
            fileUploadProgressLabel: I18n.t('file_preview.file_upload_progress')
          }),
          path: self.resource().logo_path(),
          name: self.resource().logo_file_name(),
          size: self.resource().logo_file_size()
        };
      }
    }
    else {
      fileObj = {
        dzPreview: JST['templates/dropzone-generic-img-preview']({
          previewable: false,
          nameLabel: I18n.t('file_preview.name'),
          sizeLabel: I18n.t('file_preview.size'),
          previewLabel: I18n.t('file_preview.preview'),
          removeLabel: I18n.t('file_preview.remove_file'),
          fileUploadProgressLabel: I18n.t('file_preview.file_upload_progress')
        }),
        path: $imageInput.val(),
        name: ''
      };
    }

    if ($el.length === 0) {
      return;
    }

    if (!$el[0].dropzone) {
      $el.addClass('dz-unit');

      var message = JST['templates/dropzone-generic']({
        title: I18n.t('resource.img.dropzone.resource_image', 'en'),
        maxFilesize: 2,
        optional: true,
        acceptedFiles: '.jpg, .png, .svg',
        dropFilesTitle: I18n.t('drop_file_editor.drop_file_title'),
        dragAndDrop: I18n.t('drop_file_editor.drag_and_drop'),
        browseFiles: I18n.t('drop_file_editor.browse_files'),
        dimentionLabel: I18n.t('drop_file_editor.dimensions_label'),
        maxFilesizeLabel: I18n.t('drop_file_editor.max_file_size'),
        fileTypesLabel: I18n.t('drop_file_editor.file_types'),
        optionalLable: I18n.t('drop_file_editor.optional'),
      });

      var uploadURL = Kadenze.Routes.temp_image_upload_path();
      var callbacks = {
        success: function (file, response) {
          self.resource().logo_path(response.path);
          self.resource().remove_logo(false);
        },
        removedfile: function (file) {
          self.resource().logo_path('');
          self.resource().remove_logo(true);
        },
        drop: function() {
          if(self.resourceDZ.files.length === 1){
            self.resourceDZ.removeAllFiles();
          }
        },
        error: (file, errorMessage) => {
          new Kadenze.Notice.error( { message: Kadenze.I18n.t('drop_file_editor.file_not_supported') } );
        }
      };

      var opts = {
        dzPreview: JST['templates/dropzone-generic-img-preview']({
          previewable: true,
          containerClass: 'dz-preview-wide',
          nameLabel: I18n.t('file_preview.name'),
          sizeLabel: I18n.t('file_preview.size'),
          previewLabel: I18n.t('file_preview.preview'),
          removeLabel: I18n.t('file_preview.remove_file'),
          fileUploadProgressLabel: I18n.t('file_preview.file_upload_progress'),
        }),
        acceptedFiles: '.jpg, .jpeg, .png, .svg',
        cropOptions: {
          modalId: 'crop_modal'
        },
        previewable: true
      };

      self.resourceDZ = new Kadenze.ImageDropZone(
        $el,
        message,
        uploadURL,
        callbacks,
        fileObj,
        opts
      );
    }
    else {
      self.updateLogoDropzone($el, fileObj.path);
    }
  };

  self.updateLogoDropzone = function($el, curPath) {
    var $dzel = $('.js-resource-img-dz', self.$el);
    if (!$el[0].dropzone) {
      self.initLogoDropzone();
    }
    else {
      // if any files are in the dropzone clear them
      $el[0].dropzone.removeAllFiles();
      // add file to dropzone if file exists for resource
      if (curPath && curPath !== '') {
        var fileObj = {
          name: '',
          title: '',
          size: 0,
          status: 'success'
        };
        $el[0].dropzone.emit('addedfile', fileObj);
        $el[0].dropzone.emit('thumbnail', fileObj, curPath);
        $el[0].dropzone.emit('complete', fileObj);
        $el[0].dropzone.files.push( fileObj );
      }
    }
  };

  self.hideLogoDropzone = function($el) {
    if($el) {
      $el.style.display = 'none';
    }
  };

  self.showLogoDropzone = function($el) {
    if($el) {
      $el.style.display = 'block';
    }
  };

  self.initDownloadDZ = function() {
    var $dzel = $('.js-resource-media-dz', self.$el);

    if(!$dzel.length) return;


    if ($dzel[0].dropzone) {
      var dz = $dzel[0].dropzone;
      dz.destroy();
    }

    var callbacks = {
      sending: function(file) {
        self.uploading(true);
        self.saveBtnTxt(I18n.t('dict.uploading').capitalize_first());
      },
      complete: function() {
        self.uploading(false);
        self.saveBtnTxt(I18n.t('dict.save').capitalize_first());
      },
      addedfile: function(file) {
        var dz = $dzel[0].dropzone;

        if(dz && dz.files.length > 1) {
          dz.options.autoProcessQueue = false;
          new Kadenze.Notice.info({ message: 'Remove file before adding another' });
        }
      },

      error: function(file,error) {
        mediaDZ.removeAllFiles();
        self.resource().attachment_id(null);
        self.resource().attachment(null);
        new Kadenze.Notice.error({ message: error });
      },

      removedfile: function(file) {
        const dz = $dzel[0].dropzone;

        if(dz && dz.files.length > 0) {
          $('.dz-table-preview:eq(1)').remove();
          dz.options.autoProcessQueue = true;
        }

        dz.removeAllFiles(true);

        self.resource().attachment_id(null);
        self.uploading(false);
        self.saveBtnTxt(I18n.t('dict.save').capitalize_first());

        if(file.type.match(/image/i)) {
          $('.img-responsive').remove();
          $('.dz-img-preview').remove();
        }
      },

      success: function(file, data) {
        self.uploading(false);
        self.saveBtnTxt(I18n.t('dict.save').capitalize_first());
        self.resource().attachment_id(data.files[0].id);
        self.resource().attachment(ko.mapping.fromJS(data.files[0]));
        self.resource().title(self.resource().attachment().name());
      }
    };

    var opts = {
      url: Kadenze.Routes.attachments_path(),
      dzName: I18n.t('resource.download', 'en'),
      acceptedFiles: '',
      maxFilesize: self.maxFilesize,
      maxFiles: 1,
      autoProcessQueue: true,
      clickable: true,
      previewable: true,
      playable: true,
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      paramName: 'attachment[file]',
      useKilobytes: true
        //
        // custom option added to dropzone.
        // Contacting dev to see if they'll add this feature
        //
    };

    var messageObj = {
      name: I18n.t('resource.download', 'en'),
      maxFilesize: self.maxFilesize,
    };

    var $message = $(JST['templates/dropzone-generic']({
      title: 'Drop '+ messageObj.name + ' here',
      optional: messageObj.optional,
      maxFilesize: messageObj.maxFilesize,
      acceptedFiles: messageObj.acceptedFiles,
      dropFilesTitle: I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: I18n.t('drop_file_editor.file_types'),
      optionalLable: I18n.t('drop_file_editor.optional'),
    }));

    $dzel.html($message);

    let mockFile = {};

    if (self.resource().attachment()) {
      const attach = self.resource().attachment();

      let path = '';

      if (typeof attach.url === 'function' && attach.url()) {
        path = attach.url();
      } else {
        path = attach.file.url && attach.file.url() || attach.file.file.url();
      }

      mockFile = {
        id: attach.id(),
        name: attach.name() || '',
        size: attach.size(),
        path: path,
        status: Dropzone.SUCCESS,
        type: attach.meta ? attach.meta.type() : 'unknown',
        accepted: true
      };
    }

    Kadenze.MediaDropZone($dzel, messageObj, opts, callbacks, false, mockFile);
  };

  self.fixInfoMapping = function() {
    const infoObj = self.resource().info;

    if (!infoObj['__ko_mapping__'])
      return;

    for (const prop in infoObj) {
      if (prop !== '__ko_mapping__')
        infoObj['__ko_mapping__'].mappedProperties[prop] = true;
    }
  };

  self.getJSON = function () {
    self.fixInfoMapping();

    const data = { 'resource': ko.mapping.toJS(self.resource) };

    if (self.isEmbeddedVideo) {
      delete data.resource.logo_path;
      delete data.resource.logo;
      delete data.resource.remove_logo;
    }

    return data;
  };

  self.save = silent => {
    let request;

    self.serverErrors();


    if (self.isDownload() && !self.resource().attachment_id()) {
      new Kadenze.Notice.error({ message: 'File is required' });
    } else {
      let url = Kadenze.Routes.course_resources_path(self.course_id);
      let method = 'POST';

      if (self.resource().id()) {
        url = Kadenze.Routes.course_resource_path(self.course_id, self.resource().id());
        method = 'PATCH';
      }

      self.fixInfoMapping();

      const data = self.getJSON();

      const validRequest = () => {
        if (self.isDownload()) {
          return !!(self.resource().attachment_id() && self.validate())
        } else {
          return !!self.validate()
        }
      };

      if (validRequest()) {
        self.saving(true);

        request = new Kadenze.AjaxRequest({
          url: url,
          type: method,
          timeout: 50000,
          data: data
        });

        request.done(function(data, textStatus, xhr) {
          self.resource(ko.mapping.fromJSON(data.resource));

          if (silent !== true) {
            new Kadenze.Notice.success(
              Object.assign(
                {},
                self.defaultNoticeOptions,
                { message: I18n.t('dict.save_success') }
              )
            );

            window.location = Kadenze.Routes.course_resources_path(self.course_id);
          }
        });

        request.fail(function(xhr, textStatus, errorThrown) {
          new Kadenze.Notice.error(
            Object.assign(
              {},
              self.defaultNoticeOptions,
              { message: xhr.responseJSON.errors }
            )
          );
        });

        request.always(function () {
          self.saving(false);
        });
      } else {
        new Kadenze.Notice.error({ message: self.clientErrors()[0] });
      }
    }

    return request;
  };

  self.publish = function() {
    self.changeStatusMode('published');

    if (!self.resource().id()) {
      const req = self.save(true)

      if (req)
        req.done(() => self.changeStatus());
    } else {
      self.changeStatus();
    }
  };

  self.unpublish = function() {
    self.changeStatusMode('unpublish');
    self.changeStatus();
  };

  self.changeStatus = function() {
    let path;

    if(self.isPublished()) {
      path = Kadenze.Routes.publish_course_resource_path(
        self.course_id,
        self.resource().id()
      );
    } else {
      path = Kadenze.Routes.unpublish_course_resource_path(
        self.course_id,
        self.resource().id()
      );
    }

    const result = new Kadenze.AjaxRequest({
      url: path,
      type: 'PATCH',
      dataAsJSON: false,
      timeout: 50000,
      data: self.getJSON()
    });

    result.done(function() {
      new Kadenze.Notice.success(
        Object.assign(
          {},
          self.defaultNoticeOptions,
          {
            message: I18n.t(`dict.${self.changeStatusMode()}_success`)
          }
        )
      );
      window.location = Kadenze.Routes.course_resources_path(self.course_id);
    });

    result.fail(function(xhr, textStatus, errorThrown) {
      new Kadenze.Notice.error(
        Object.assign(
          {},
          self.defaultNoticeOptions,
          { message: xhr.responseJSON.errors }
        )
      );
    });
  };

  self.validate = function() {
    self.clientErrors = ko.validation.group(self.resource, { deep: true });

    if (
      !self.clientErrors().length || (
        self.clientErrors().length === 1 && self.clientErrors()[0] === null
      )
    ) {
      return true;
    } else {
      self.clientErrors.showAllMessages();
      return false;
    }
  };

  self.bindData = function(data) {
    const mapping = {
      'attachment': {
        create: function(options) {
          let ret = ko.mapping.fromJS(options.data);

          if (typeof ret != 'function')
            ret = ko.observable(ret);

          return ret;
        }
      },
      'info': {
        update: function(options) {
          if (self.resource && typeof self.resource === 'function' && self.resource()) {
            return self.resource().info;
          } else {
            return ko.mapping.fromJS(options.data);
          }
        }
      }
    };

    self.changeStatusMode(data.status)

    if (typeof data === 'string')
      data = JSON.parse(data);

    const ext_data = Object.assign({}, data, { remove_logo: false });

    self.resource(ko.mapping.fromJS(ext_data, mapping));

    //Initialize the info attribute as an object if it hasn't been already
    if (typeof self.resource().info != 'object')
      self.resource().info = {};

    if (typeof self.resource().type === 'function' && !_.isEmpty(self.resource().type()))
      self.resource_type(self.resource().type());

    self.canPublish = ko.computed(() => !self.isPublished())
    self.isSaved = ko.computed(() => !!self.resource().id())

    self.saveButtonText = ko.computed(() => {
      return self.isSaved() ? I18n.t('dict.update') : I18n.t('dict.save');
    });
  };

  self.disposePreviousResourceValidations = function(resourceType) {
    // The validations that are disposed here are re established every time a resource
    // is selected via the 'initObservable' bindings in _resource_form_content.html.haml.
    _.each(self.resource().info, function(val, key) {
      if(!_.isUndefined(val) && _.isFunction(val) && _.isFunction(val._disposeValidation)) {
        val._disposeValidation();
      }
    });

    // This validation is dynamically added in the resource_type subscription
    // below and must be disposed if the newly selected resourceType is NOT a
    // DownloadResource, otherwise all following selected resources will
    // trigger the validation. This validation is re established via the same subscription.
    if(resourceType !== 'DownloadResource' && _.isFunction(self.resource().attachment._disposeValidation)) {
      self.resource().attachment._disposeValidation();
    }
  };

  const __construct = function(that) {
    if (!skipBinding)
      that.bindData(data)

    setTimeout(that.initUI, 500);
    //
    // TODO: Need a custom knockout binding for dropzones to make this work right.
    //

    that.resource_type.subscribe(function(newVal) {
      console.log('resource type: ' + newVal);
      self.resource().type = newVal;

      //
      // Resource validations (that were created in the markup via the
      // 'initObservable' binding) need to be disposed so validations of
      // all previously selected resources aren't triggered. See KADWEB-6353
      //
      self.disposePreviousResourceValidations(newVal);

      if (newVal === 'DownloadResource') {
        that.resource().attachment.extend({ required: true });
        that.initDownloadDZ();
      }

      $('.bootstrap-select').removeClass('open');
        //
        // not sure why it doesn't close the dropdown menu by default,
        // so this can be considered a hack
        //

      //
      // Remove the null option if the user changes the type to something valid
      // See KADWEB-9849
      //
      if(!_.isUndefined(newVal)) {
        let $list = $('button[data-id=\'resourceSelectMenu\']').next();
        $list.find('li').first().remove();
        $('#resourceSelectMenu').find('option:contains(\'Select Resource Type\')').remove();
      }
    });

    if (!self.$el || !self.$el.length)
      self.$el = $('#' + self.domId())
  }(this);

  return self
}
